import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* ✅ Wrap everything with HelmetProvider */}
    <HelmetProvider>
      <BrowserRouter>
        {/* <BrowserRouter basename={process.env.REACT_APP_BASE_URL_PATH || '/'}> */}
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
